import React, { Component } from 'react';
import { withRouter } from 'react-router';
import * as routes from 'constants/routes.js';

function getTitleByRoute(pathname) {
    if (routes.bonus.match(pathname)) {
        return 'Бонус';
    }
    if (routes.profile.match(pathname)) {
        return 'Профиль';
    }
    if (routes.projects.match(pathname) ||
        routes.project_application.match(pathname) ||
        routes.project_edit.match(pathname)  ||
        routes.project_application_edit.match(pathname)) {
        return 'Проекты';
    }
    if (routes.configurator.catalog.match(pathname)) {
        return 'Каталог';
    }
    if (routes.configurator.design.match(pathname)) {
        return 'Коллекция';
    }
    if (routes.products.match(pathname)) {
        return 'Продукты';
    }
    if (routes.notifications.match(pathname)) {
        return 'Уведомления';
    }
}

class RouteTitle extends Component {
    render() {
        const {location, className} = this.props;
        return (
            <h3 className={className}>
                {getTitleByRoute(location.pathname)}
            </h3>
        )
    }
}

export default withRouter(RouteTitle);



// WEBPACK FOOTER //
// ./src/components/pages/RouteTitle.js